export default __webpack_public_path__ + "static/media/40178.98a1e33d.jpg";